<template>
  <div class="setting-page">
    <top-bar :topbarList="settingTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";

import { settingIndexMixins } from "@/mixins/settingIndexMixins";

export default {
  mixins: [settingIndexMixins, commonFuc],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.setting-page {
  height: 100%;
}
</style>
